<template>  
    <div class="login-container">  
      <h1>登录</h1>  
      <div class="tabs">  
        <button @click="activeTab = 'username'" :class="{ active: activeTab === 'username' }">账号密码登录</button>  
        <button @click="activeTab = 'phone'" :class="{ active: activeTab === 'phone' }">验证码登录</button>  
      </div>  
      <div class="form">  
        <div v-if="activeTab === 'username'">  
          <div class="input-group"> 
            <span class="icon"><i class="fas fa-user"></i></span> <!-- 用户名图标 -->   
            <input v-model="usercode" type="text" placeholder="用户名" />  
          </div>
          <div class="input-group">
            <span class="icon"><i class="fas fa-lock"></i></span> <!-- 密码图标 --> 
            <input 
              :type="isPasswordVisible ? 'text' : 'password'"
              v-model="password" 
              placeholder="密码" 
            /> 
            <span class="toggle-eye" @click="togglePasswordVisibility">  
            
            </span>
          </div> 
        </div>  
        <div v-else>  
          <div class="phone-input-container">
            <input v-model="phone" type="text" placeholder="手机号" class="input-field" />  
            <button @click="sendCode" class="send-code-button" :disabled="isCodeSent">
              {{ isCodeSent ? countdown + '秒后重发' : '发送验证码' }}
            </button> 
          </div>
          <input v-model="code" type="text" placeholder="验证码" class="input-field" />     
        </div>  
        <button @click="handleLogin" class="login-button">登录</button>  
        <p v-if="errorMsg" class="error">{{ errorMsg }}</p>  
      </div>  
      
      <!-- 显示页面加载动画 -->
      <div v-if="loading" class="loader-overlay">
        <div class="loader">  
          <svg class="spinner" viewBox="0 0 50 50">  
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5" />  
          </svg>  
          <p> 正在努力加载...</p>
        </div>  
      </div> 

    </div>  
  </template>  
  
  <script>  
  import { defineComponent, ref, onBeforeUnmount, getCurrentInstance } from 'vue';  
  import { customerData, productData, algorithmsData, versionTypeData, statusData} from '@/utils/publicdata'; 
  import { saveToStorage, parseTableData } from '@/utils/dateFormatter'
  import { useRouter } from 'vue-router';  
  import { debounce } from 'lodash';   // 使用防抖
  import axios from 'axios';

  export default defineComponent({  
    setup() {  
      // 声明响应式数据  
      const router = useRouter();  // 获取路由实例  
      const activeTab = ref('username'); // 默认显示账号密码登录的页签tab  
      const usercode = ref('');           // 登录时输入的用户编号   
      const password = ref('');           // 登录时输入的用户密码  
      const systemcode = ref('uam');      // 登录的系统代码，由系统默认   
      const mobilephone = ref('');        // 登录时输入的手机号码  
      const code = ref('');               // 登录时输入的验证码  
      const errorMsg = ref('');  
      const countdown = ref(60);          // 倒计时60秒  
      const isCodeSent = ref(false);      // 控制发送验证码按钮状态  
      const isLoggingIn = ref(false);     // 用于控制登录按钮的点击状态
      const isPasswordVisible = ref(false); // 控制密码的显隐状态
      const loading = ref(false);         // 控制数据加载标志
      const { proxy } = getCurrentInstance();
      
      let timer = null;                   // 用于存储定时器 
      
      const togglePasswordVisibility = () => {
        isPasswordVisible.value = !isPasswordVisible.value;
      } 
       
      const handleLogin = async() => {  
        if (!usercode.value || !password.value) {
          errorMsg.value = '用户名和密码不能为空！';
        } else {
          if (isLoggingIn.value) return;   // 若正在登录则返回

          isLoggingIn.value = true;   // 设置为正在登录状态
          loading.value = true;

          errorMsg.value = '';  

          let response;  //声明块级作用域变量response，防止变量在不同响应下受到污染    

          try {
            if (activeTab.value === 'username') {  
              response = await loginWithUsername(usercode.value, password.value);  
            } else {  
              response = await loginWithPhone(mobilephone.value, code.value);  
            }  

            if (response.status === 0) {   
              // 取出登录成功后端返回的数据
              const { token, userid, username, lastlogintime } = response.data;
              // 存储用户信息到 localStorage  
              saveToStorage('userInfo', {
                token,  
                userid,
                username,  
                lastlogintime,
              });
              
              //  console.log( response.data );
              
              // 登录成功后获取权限及卡片信息(修改到主界面中，防止刷新数据丢失，登录只等待)
              await loaduserdata(userid, token);

              // 跳转到主页面 
              router.push('/main');  
            } else {  
              errorMsg.value = response.message || response.data.message; // 显示错误信息  
            } 
          } catch(error) {
            errorMsg.value = '登录过程中发生异常，请稍后重试！';
          } finally {
            isLoggingIn.value = false;   // 结束登录标志
            loading.value = false;   //结束加载
          } 
        }
      };

      const debouncedLogin = debounce(handleLogin, 1000); // 防抖处理 

      const loginWithUsername = async(usercode, password) => { 
        try {
          const response = await axios.post(proxy.$config.API_BASE_URL + `/rest/user/login`, {
            usercode,
            password,
            systemcode: systemcode.value
          }, 
          {
            headers: {  
            'Content-Type': 'application/json'  
            }
          });
        //  console.log(response.data);
          return {  
            status: response.data.status || 0,    // 若服务端返回则取服务端的返回状态
            message: response.data.message,
            data: response.data   // 后端返回的数据  
          };   
        }         
        catch(error) {
        //  console.log(error);
          let errorMessage = '登录请求失败，请重试！';  // 默认错误消息  

          // 检查 error 对象  
          if (error.response) { // 请求已发出且服务器响应了  
            errorMessage = error.response.data?.message || errorMessage; // 尝试获取后端返回的错误消息  
          } 
          else 
          if (error.request) { // 请求已发出但没有响应  
             errorMessage = '服务器没有响应，请检查您的网络连接。';  
          } 
          else { // 触发了其他错误  
            errorMessage = error.message; // 使用 Axios 返回的原始错误消息  
          }  
          return {  
            status: 1,    // 返回异常时状态标志1
            message: errorMessage   // 返回API调用异常的错误信息 
          }; 
        }
      };

      const loginWithPhone = async(phone, code) => {  
        // TODO: 用于与后端 API 的实际调用  
        return new Promise(resolve => {  
          setTimeout(() => {  
            if (phone === '12345678901' && code === '123456') {  
              resolve({ success: true });  
            } else {  
              resolve({ success: false, message: '手机号或验证码错误' });  
            }  
          }, 1000);  
        });  
      };

      const sendCode = () => {  
        // 此处集成实际发送验证码逻辑  
        alert('验证码已发送！');  

        // 发送验证码后，开始倒计时
        isCodeSent.value = true;
        countdown.value = 60;     // 重置倒计时时间

        // 开始倒计时
        timer = setInterval(() => {
          countdown.value -= 1;
          if (countdown.value <= 0) {
            clearInterval(timer);    // 清除定时器
            isCodeSent.value = false;      // 启用发送按钮
            countdown.value = 60;          // 重置倒计时
          } 
        }, 1000);
      };  

      const loaduserdata = async(userid, token) => {
        try {  

          // 获取客户信息
          const customerResponse = await axios.post(proxy.$config.API_BASE_URL + `/rest/querydata`, {
              token,
              querymethod: 'getcustomerinfo'
            },
            {
              headers: {  
              'Content-Type': 'application/json'  
              } 
            });

            // 获取产品信息
            const productResponse = await axios.post(proxy.$config.API_BASE_URL + `/rest/querydata`, {
              token,
              querymethod: 'getproductinfo'
            },
            {
              headers: {  
              'Content-Type': 'application/json'  
              } 
            });

            // 获取算法类型
            const algorithmsResponse = await axios.post(proxy.$config.API_BASE_URL + `/rest/querydata`, {
              token,
              querymethod: 'getalgorithminfo'
            },
            {
              headers: {  
              'Content-Type': 'application/json'  
              } 
            });
  
            // 获取版本类型
            const versionResponse = await axios.post(proxy.$config.API_BASE_URL + `/rest/querydata`, {
              token,
              querymethod: 'getversiontype'
            },
            {
              headers: {  
              'Content-Type': 'application/json'  
              } 
            });

            // 授权日期状态
            const statusItemResponse = await axios.post(proxy.$config.API_BASE_URL + `/rest/querydata`, {
              token,
              querymethod: 'getstatusitem'
            },
            {
              headers: {  
              'Content-Type': 'application/json'  
              } 
            });

            customerData.value = parseTableData(customerResponse.data);          // 用户信息
            productData.value = parseTableData(productResponse.data);            // 产品信息
            algorithmsData.value = parseTableData(algorithmsResponse.data);      // 算法类型
            versionTypeData.value = parseTableData(versionResponse.data);        // 版本类型
            statusData.value = parseTableData(statusItemResponse.data);          // 到期标志  

            // 将结果保存到本地
            saveToStorage('customerInfo', customerData.value);
            saveToStorage('productInfo', productData.value);
            saveToStorage('algorithmsInfo', algorithmsData.value);
            saveToStorage('versionTypeInfo',  versionTypeData.value);
            saveToStorage('statusInfo',  statusData.value);

            // 延时登录1s
            return new Promise((resolve) => {
              setTimeout(() => {
                resolve({ token, userid })
              }, 1000);
          })
        } catch (error) {  
          alert('加载数据时出错:', error);  
        } 
      };  

      onBeforeUnmount(() => {
        // 组件销毁前清除定时器，防止内存泄漏 
        clearInterval(timer);
      });
      
      return {  
        activeTab,  
        usercode,  
        password,  
        mobilephone,  
        code,  
        errorMsg,  
        countdown,  
        isCodeSent,  
        isLoggingIn,
        loading,
        handleLogin: debouncedLogin, // 使用防抖处理的登录方法  
        isPasswordVisible,
        togglePasswordVisibility,
        sendCode,
      };    
    }
  });  
  </script>  
  
  <style scoped>  
  .login-container {  
    max-width: 400px;  
    margin: auto;  
    padding: 20px;  
    border: 1px solid #ccc;  
    border-radius: 8px;  
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);  
  }  

  .loader-overlay {  
    position: fixed; /* 固定的定位 */  
    top: 0;  
    left: 0;  
    width: 100%;  
    height: 100%;  
    background-color: rgba(0, 0, 0, 0.5); /* 半透明黑幕 */  
    display: flex;  
    justify-content: center; /* 水平居中 */  
    align-items: flex-end; /* 垂直居中 */  
    padding-bottom: 20vh;  /* 使用视窗单位控制偏移量 */ 
    z-index: 1000; /* 确保在最上层 */  
  }  

  .loader {  
    display: flex;  
    flex-direction: column;  
    align-items: center;  
    font-size: 12px;
    color: #ccc;
    transform: translateY(-50%);  /* 微调垂直位置 */
  }  

  .spinner {  
    animation: rotate 2s linear infinite;  
    width: 40px;  
    height: 40px;  
  } 

  .path {  
    stroke: #007bff;  
    animation: dash 1.5s ease-in-out infinite;  
  }  

  .input-group {  
    position: relative;  
    margin-bottom: 20px;  
    overflow: hidden;         /* 防止内容超出输入范围 */
  }  

  .input-group .icon {  
    position: absolute;  
    left: 10px;  
    top: 50%;  
    transform: translateY(-50%);  /* 垂直居中 */
    color: #888;  
  }  

  .input-group input {  
    padding: 10px 10px 10px 40px;  
    width: 100%;  
    border: 1px solid #ccc;  
    border-radius: 4px;  
    box-sizing: border-box; /* 确保包括内边距和边框在内 */ 
  }  

  .toggle-eye {  
    position: absolute;  
    right: 10px;  
    top: 50%;  
    transform: translateY(-50%);  
    cursor: pointer;  
    color: #888;  
  } 

  .tabs {  
    display: flex;  
    justify-content: space-between;  
    margin-bottom: 20px;  
  }  

  .tabs button {  
    flex: 1;  
    padding: 10px;  
    border: none;  
    background-color: #f0f0f0;  
    cursor: pointer;  
  }  

  .tabs button.active {  
    background-color: #007bff;  
    color: white;  
  }  

  .input-field {
    width: 100%; /* 设置输入框宽度为100% */  
    padding: 10px;  
    margin: 8px 0;  
    border: 1px solid #ccc;  
    border-radius: 4px;  
    box-sizing: border-box; /* 包含内边距 */ 
  }

  .phone-input-container {  
    position: relative; /* 定位容器以便绝对定位按钮 */  
  }  

  .send-code-button {  
    position: absolute;  
    right: 5px; /* 将按钮放入输入框的右侧 */  
    top: 50%;  
    transform: translateY(-50%);  
    padding: 5px 10px;  
    border: none;  
    border-radius: 5px;
    background-color: #007bff;  
    color: white;  
    cursor: pointer;  
  } 

  .send-code-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    color: #666;
  } 

  .login-button {  
    width: 100%; /* 登录按钮宽度与输入框一致 */  
    padding: 10px;  
    margin: 8px 0;  
    border: none;  
    border-radius: 5px; 
    background-color: #007bff;  
    color: white;  
    cursor: pointer; /* 设置为手型光标 */  
  }  

  .error {  
    color: red;  
    font-size: 12px;
  }  

  @keyframes rotate {  
    0% {  
      transform: rotate(0deg);  
    }  
    100% {  
      transform: rotate(360deg);  
    }  
  }  

  @keyframes dash {  
    0% {  
      stroke-dasharray: 1, 200;  
      stroke-dashoffset: 0;  
    }  
    50% {  
      stroke-dasharray: 90, 200;  
      stroke-dashoffset: -35;  
    }  
    100% {  
      stroke-dasharray: 90, 200;  
      stroke-dashoffset: -124;  
    }  
  }  

  </style> 